(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/teams-create-invite.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/teams-create-invite.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const logger = svs.arena.logger;
const _svs$ui$reactForm = svs.ui.reactForm,
  Form = _svs$ui$reactForm.Form,
  ControlGroup = _svs$ui$reactForm.ControlGroup;
const Button = svs.ui.ReactButton;
const Icon = svs.ui.ReactIcon;
const AmountInput = svs.ui.reactFormInputs.AmountInput;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const fetchTeams = svs.arena.store.teams.actions.fetchTeams;
const _svs$arena$constants = svs.arena.constants,
  routes = _svs$arena$constants.routes,
  depositType = _svs$arena$constants.depositType;
const createTeamInviteId = svs.arena.store.teams.actions.createTeamInviteId;
const TeamShowLink = svs.arena.pages.teams.components.TeamShowLink;
const TeamsCreateInvite = _ref => {
  let createdTeamId = _ref.createdTeamId;
  const dispatch = ReactRedux.useDispatch();
  const history = useHistory();
  const _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    initialDeposit = _React$useState2[0],
    setInitialDeposit = _React$useState2[1];
  const _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isShowInviteLinkButtonDisabled = _React$useState4[0],
    setIsShowInviteLinkButtonDisabled = _React$useState4[1];
  const _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isGotoMyTeamsButtonDisabled = _React$useState6[0],
    setIsGotoMyTeamsButtonDisabled = _React$useState6[1];
  const _React$useState7 = React.useState(true),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    showButtonInviteLink = _React$useState8[0],
    setShowButtonInviteLink = _React$useState8[1];
  const handleOnAmountChange = e => {
    logger.debug('**** handleOnAmountChange, e: ', e);
    setInitialDeposit(e.target.value);
  };
  const submitForm = async (e, formData, isValid) => {
    logger.debug('**** submitForm, e: ', e);
    e.preventDefault();
    if (isShowInviteLinkButtonDisabled) {
      return;
    }
    setIsShowInviteLinkButtonDisabled(true);
    logger.debug('submitForm, formData', formData);
    logger.debug('submitForm, isValid', isValid);
    if (!isValid) {
      setIsShowInviteLinkButtonDisabled(false);
      return;
    }
    logger.debug('OK! lets submitForm :)');
    const trackTeamLink = {
      category: 'spela-tillsammans',
      action: 'new_team_show_link',
      opt_label: 'yes'
    };
    svs.components.analytics.trackEvent(trackTeamLink);
    svs.arena.logger.debug('TeamInviteLink, createNewLink, teamId:', createdTeamId);
    const deposit = initialDeposit && initialDeposit > 0 ? initialDeposit : 0;
    const trackRecommendedDeposit = {
      category: 'spela-tillsammans',
      action: 'recommended_deposit',
      opt_label: deposit === 0 ? 'no' : 'yes'
    };
    svs.components.analytics.trackEvent(trackRecommendedDeposit);
    const linkData = await dispatch(createTeamInviteId({
      teamId: createdTeamId,
      initialDeposit: deposit
    }));
    svs.arena.logger.debug('TeamInviteLink, createdNewLink, linkData:', linkData);
    setShowButtonInviteLink(false);
  };
  const setDepositData = async () => new Promise(resolve => {
    svs.components.Storage.browser.set('syndicateDepositAmount', 'syndicate', {
      amount: initialDeposit,
      syndicateId: createdTeamId,
      depositType: depositType.CREATE
    }, svs.components.Storage.constants.EXPIRES_10M, () => {
      resolve();
    });
  });
  const handleButtonGotoTeam = async () => {
    var _teamsNew$payload;
    if (isGotoMyTeamsButtonDisabled) {
      logger.debug('**** handleButtonGotoTeam, setIsGotoMyTeamsButtonDisabled: ', setIsGotoMyTeamsButtonDisabled);
      return;
    }
    setIsGotoMyTeamsButtonDisabled(true);
    if (initialDeposit && initialDeposit > 0) {
      await setDepositData();
    }
    const teamsNew = await dispatch(fetchTeams());
    const foundTeam = teamsNew === null || teamsNew === void 0 || (_teamsNew$payload = teamsNew.payload) === null || _teamsNew$payload === void 0 || (_teamsNew$payload = _teamsNew$payload.data) === null || _teamsNew$payload === void 0 ? void 0 : _teamsNew$payload.find(team => team.syndicateId === createdTeamId);
    logger.debug('**** handleButtonGotoTeam, teamsNew, createdTeamId, yes: ', teamsNew, createdTeamId, foundTeam);
    if (foundTeam) {
      logger.debug('**** handleButtonGotoTeam, foundTeam yes!, navigate to my teams');
      history.push(routes.TEAMS);
    } else {
      logger.debug('**** handleButtonGotoTeam, did NOT foundTeam, navigate to wait page');
      history.push({
        pathname: routes.TEAMS_WAIT_FOR_BACKEND,
        search: "?teamId=".concat(createdTeamId)
      });
    }
  };
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "align-center"
  }, React.createElement(Icon, {
    icon: "win",
    size: "1000"
  })), React.createElement("h2", {
    className: "margin-top-2 margin-bottom-1 f-medium align-center h2"
  }, React.createElement("span", {
    className: "f-medium"
  }, "Grattis till ditt nya lag!")), React.createElement("h3", {
    className: "margin-top-0 f-medium align-center h3"
  }, React.createElement("span", {
    className: "f-medium"
  }, "Nu \xE4r det dags att bjuda in dina kompisar.")), showButtonInviteLink && React.createElement(Form, {
    id: "create-team-form",
    method: "POST",
    onSubmit: submitForm
  }, React.createElement(React.Fragment, null, React.createElement(ControlGroup, {
    infoMessage: "Ange en summa f\xF6r lagmedlemmarna att s\xE4tta in n\xE4r de g\xE5r med i laget s\xE5 att ni kan komma ig\xE5ng s\xE5 fort som m\xF6jligt.",
    v2: true
  }, React.createElement(AmountInput, {
    errorMessageDefault: "Felaktigt angivet belopp. Ange belopp i hela kronor.",
    errorMessageMax: "Det h\xF6gsta beloppet du kan ange \xE4r 1 000 kr",
    errorMessageMin: "Minsta ins\xE4ttningsbelopp \xE4r 1 kr.",
    helpMessage: "Ange belopp i kronor",
    id: "initialDepositInput",
    isCentsAllowed: false,
    isRequired: false,
    label: "Valfri rekommenderad \xF6verf\xF6ring",
    max: 1000,
    min: 0,
    name: "initialDepositInput",
    onChange: handleOnAmountChange,
    value: initialDeposit
  })), React.createElement(Button, {
    block: true,
    className: "margin-top-1",
    disabled: isShowInviteLinkButtonDisabled,
    inverted: true,
    size: 300,
    type: "submit"
  }, "Visa inbjudningsl\xE4nk"))), !showButtonInviteLink && React.createElement(React.Fragment, null, React.createElement("div", null, "H\xE4r \xE4r l\xE4nken du anv\xE4nder f\xF6r att bjuda in:"), React.createElement("div", {
    className: "margin-top-1"
  }, React.createElement(TeamShowLink, {
    isCreate: true,
    teamId: createdTeamId
  }), React.createElement(Button, {
    block: true,
    className: "margin-top-1",
    disabled: isGotoMyTeamsButtonDisabled,
    onClick: handleButtonGotoTeam,
    size: 300,
    transparent: true
  }, "G\xE5 till mina lag"))));
};
svs.arena.pages.teams.components.TeamsCreateInvite = TeamsCreateInvite;

 })(window);